/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable babel/camelcase */
import BiliAjax from '@bilibili/bjax'
import request from '@plat-components/utils2/_esm5/request'
import toast from '@bilibili/vanilla-toast'
import { getCookie } from '@plat-components/utils2/_esm5/cookie'
import { AbstractInterface, ReserveListData, UserInfo, Award, RankDataList } from '../types'
// import { useMock, APIHost } from './config'
let isUat = false
let isPre = false
export let isDebug = false
export const isScreen = window.innerHeight <= 667
const pattern1 = /\/preview\//;
const pattern2 = /\/preview\/v\//;

if (location.href.includes('isDebug=1')) {
  isDebug = true
}

/* query 参数 */
const url = new URL(location.href);
const searchParams = new URLSearchParams(url.search);
const vmid = searchParams.get('mid');


if ((pattern1.test(location.href)&&!pattern2.test(location.href)) || location.hostname.includes('uat-')) {
  isUat = true
}
if (pattern2.test(location.href) || location.hostname.includes('pre-')) {
  isPre = true
}
const APIHost = `https://${ isUat ? 'uat-' : isPre ? 'pre-' : ''}api.bilibili.com`
export const http = new BiliAjax({})
const csrf = getCookie('bili_jct')

const errHandler = (err: Error) => {
  const msg = err.message || '服务出现一点小问题，请稍后重试'
  toast.info(msg)
  return Promise.reject(msg)
}

export const getUserInfo = async () => {
  return http.user()
}


// 获取运营数据源（tab标签集合）
export const getTabsData = async (mid?: number) => {
  try {
    const res: any = await http
      .get(`${APIHost}/x/activity/operation/list`, {
        source_id: '65f3f53d2007d629e528604f',
        // mid: vmid?vmid:mid,
      })
    if (res.code !== 0) throw new Error(res.message)
    return Promise.resolve(res.data as any)
  } catch (err:any) {
    errHandler(err)
    return Promise.reject(err.message)
  } 
}
// 获取投票数据
export const getVoteData = async (actId: number, groupId: number) => {
  try {
    const res: any = await http
      .get(`${APIHost}/x/activity/vote_new/rank`, {
        pn: 1,
        ps: 10,
        activity_id: actId,
        datasource_group_id: groupId,
        sort: 3
      })
    if (res.code !== 0) throw new Error(res.message)
    return Promise.resolve(res.data as any)
  } catch (err:any) {
    return Promise.reject(err.message)
  } 
}
// 投票
export const VoteDo = async (actId: number, groupId: number, datasourceItemId: number) => {
  try {
    const res: any = await http
      .post(`${APIHost}/x/activity/vote_new/do`, {
        activity_id: actId,
        datasource_group_id: groupId,
        datasource_item_id: datasourceItemId,
        vote: 1
      })
    if (res.code !== 0) throw new Error(res.message)
    return Promise.resolve(res.data as any)
  } catch (err:any) {
    errHandler(err)
    return Promise.reject(err.message)
  } 
}


export const getPosterData = async (mid: number) => {
  try {
    const res: any = await http
      .get(`${APIHost}/x/operational_activity/dont_kill/view_data`, {
        mid: vmid?vmid:mid,
      })
    if (res.code !== 0) throw new Error(res.message)
    return Promise.resolve(res.data as RankDataList)
  } catch (err:any) {
    errHandler(err)
    return Promise.reject(err.message)
  } 
}

export const getSupportData = async (mid: number) => {
  try {
    const res: any = await http
      .get(`${APIHost}/x/operational_activity/dont_kill/view_rank`, {
        mid: vmid?vmid:mid,
      })
    if (res.code !== 0) throw new Error(res.message)
    return Promise.resolve(res.data as RankDataList)
  } catch (err:any) {
    errHandler(err)
    return Promise.reject(err.message)
  } 
}


export const b64toBlob =(b64Data: string, contentType='', sliceSize=512) => {
  const byteCharacters = atob(b64Data)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }

  const blob = new Blob(byteArrays, { type: contentType })
  return blob
}


export const uploadAvatarImg = async (imgB64: string, fileName: string) => {
  const [ , imgB ] = imgB64.split('base64,')
  const blob = b64toBlob(imgB, fileName.indexOf('.png') > 0 ? 'image/png' : 'image/jpeg')
  const formData = new FormData()
  formData.append('bucket', 'active')
  formData.append('file', blob, 'image.png')
  // 直接使用线上地址，pre-api 生成的图片访问会受限
  return http.upload(`https://api.bilibili.com/x/upload/web/image`, formData).then((data: any) => {
    if (data.code === 0 && data.data && data.data.location) {
      return data.data.location
    } else {
      return Promise.reject()
    }
  })
}

export default {
  getUserInfo,
}
